import { PolicyResource } from "@vmosolutions/oc-interfaces";
import { ITableColumn } from "src/components/FilterSearchTable/TableComponents/TableHeader";

/////////////////////////////////////////////////////
/////             STATIC TABLE DATA            //////
/////////////////////////////////////////////////////

// const tableTitle: string = "Advanced Search";
// const tableDescription: string = "Select an event type and apply filters to help find the desired filight in the table.";
// const NoDataMessage: string = "No events to display.";

// ASSIGNED FLIGHTS
export const assignedFlightsTableDesc = {
  tableTitle: "Flights",
  // tableDescription: "To un-assign a flight,  use the filter drop down to find the desired events. Once found, select from the drop-down menu to unassign your flight.",
  tableDescription: "",
  noMessage: "No flights to display, use the filter above to search.",
};
export const assignedFlightsTableInfo: ITableColumn[] = [
  {
    id: "_id",
    value: "_id",
    index: 0,
    numeric: true,
    label: "FlightChip",
    type: "string",
    width: 10,
    visible: true,
    filter: false,
  },
  {
    id: "aircraft[registration]",
    value: "aircraft[registration]",
    index: 1,
    numeric: true,
    label: "Aircraft",
    type: "string",
    width: 10,
    visible: true,
    filter: true,
  },
  {
    id: "aircraft[aircraftType][title]",
    value: "aircraft[aircraftType][title]",
    index: 2,
    numeric: true,
    label: "Aircraft Type",
    type: "string",
    width: 10,
    visible: true,
    filter: true,
  },
  {
    id: "origin",
    value: "origin",
    index: 3,
    numeric: true,
    label: "Origin",
    type: "string",
    width: 10,
    visible: false,
    filter: true,
  },
  {
    id: "destination",
    value: "destination",
    index: 4,
    numeric: true,
    label: "Destination",
    type: "string",
    width: 10,
    visible: false,
    filter: true,
  },
  {
    id: "scheduledOut",
    value: "scheduledOut",
    index: 5,
    numeric: true,
    label: "Sched Out",
    type: "date",
    width: 10,
    visible: true,
    filter: true,
  },
  {
    id: "scheduledOff",
    value: "scheduledOff",
    index: 6,
    numeric: true,
    label: "Sched Off",
    type: "date",
    width: 10,
    visible: true,
    filter: true,
  },
  {
    id: "scheduledOn",
    value: "scheduledOn",
    index: 7,
    numeric: true,
    label: "Sched On",
    type: "date",
    width: 10,
    visible: true,
    filter: true,
  },
  {
    id: "scheduledIn",
    value: "scheduledIn",
    index: 8,
    numeric: true,
    label: "Sched In",
    type: "date",
    width: 10,
    visible: true,
    filter: true,
  },
  {
    id: "actualOut",
    value: "actualOut",
    index: 9,
    numeric: true,
    label: "Actual Out",
    type: "date",
    width: 10,
    visible: false,
    filter: true,
  },
  {
    id: "actualOff",
    value: "actualOff",
    index: 10,
    numeric: true,
    label: "Actual Off",
    type: "date",
    width: 10,
    visible: false,
    filter: true,
  },
  {
    id: "actualOn",
    value: "actualOn",
    index: 11,
    numeric: true,
    label: "Actual On",
    type: "date",
    width: 10,
    visible: false,
    filter: true,
  },
  {
    id: "actualIn",
    value: "actualIn",
    index: 12,
    numeric: true,
    label: "Actual In",
    type: "date",
    width: 10,
    visible: false,
    filter: true,
  },
  {
    id: "customer[name]",
    value: "customer[name]",
    index: 13,
    numeric: true,
    label: "Customer",
    type: "object",
    width: 10,
    visible: true,
    filter: true,
  },
  {
    id: "flags[description]",
    value: "flags[description]",
    index: 14,
    numeric: true,
    label: "Flight Flags",
    type: "string",
    width: 10,
    visible: true,
    filter: true,
  },
  {
    id: "validationStatus",
    value: "validationStatus",
    index: 15,
    numeric: true,
    label: "Validation Status",
    type: "string",
    width: 10,
    visible: false,
    filter: true,
  },
  {
    id: "batchId",
    value: "batchId",
    index: 16,
    numeric: true,
    label: "Batch Id",
    type: "string",
    width: 10,
    visible: false,
    filter: true,
  },
  {
    id: "createdBy",
    value: "createdBy",
    index: 17,
    numeric: true,
    label: "Created By",
    type: "string",
    width: 10,
    visible: false,
    filter: true,
  },
  {
    id: "createdAt",
    value: "createdAt",
    index: 18,
    numeric: true,
    label: "Created At",
    type: "date",
    width: 10,
    visible: false,
    filter: true,
  },
  {
    id: "modifiedBy",
    value: "modifiedBy",
    index: 19,
    numeric: true,
    label: "Modified By",
    type: "string",
    width: 10,
    visible: false,
    filter: true,
  },
  {
    id: "modifiedAt",
    value: "modifiedAt",
    index: 20,
    numeric: true,
    label: "Modified At",
    type: "date",
    width: 10,
    visible: false,
    filter: true,
  },
  // { id: "flightType[title]", value: "flightType[title]", index: 11, numeric: true, label: "Flight Type", type: "object", width: 10, visible: true, filter: true },
];

// GROUND EVENTS
export const groundEventsTableDesc = {
  tableTitle: "Ground Events",
  tableDescription: "",
  noMessage: "No ground events to display, use the filter above to search.",
};
export const groundEventsTableInfo: ITableColumn[] = [
  {
    id: "_id",
    value: "_id",
    index: 0,
    numeric: true,
    label: "EventChip",
    type: "string",
    width: 10,
    visible: true,
    filter: false,
  },
  {
    id: "aircraft[registration]",
    value: "aircraft[registration]",
    index: 1,
    numeric: true,
    label: "Aircraft",
    type: "string",
    width: 10,
    visible: true,
    filter: true,
  },
  {
    id: "eventType[title]",
    value: "eventType[title]",
    index: 2,
    numeric: true,
    label: "Type",
    type: "object",
    width: 10,
    visible: true,
    filter: true,
  },
  {
    id: "title",
    value: "title",
    index: 3,
    numeric: true,
    label: "Title",
    type: "string",
    width: 10,
    visible: true,
    filter: true,
  },
  {
    id: "location",
    value: "location",
    index: 3,
    numeric: true,
    label: "Location",
    type: "string",
    width: 10,
    visible: true,
    filter: true,
  },
  {
    id: "scheduledStart",
    value: "scheduledStart",
    index: 4,
    numeric: true,
    label: "Sched Start",
    type: "date",
    width: 10,
    visible: true,
    filter: true,
  },
  {
    id: "scheduledEnd",
    value: "scheduledEnd",
    index: 5,
    numeric: true,
    label: "Sched End",
    type: "date",
    width: 10,
    visible: true,
    filter: true,
  },
  {
    id: "actualStart",
    value: "actualStart",
    index: 4,
    numeric: true,
    label: "Actual Start",
    type: "date",
    width: 10,
    visible: false,
    filter: true,
  },
  {
    id: "actualEnd",
    value: "actualEnd",
    index: 5,
    numeric: true,
    label: "Actual End",
    type: "date",
    width: 10,
    visible: false,
    filter: true,
  },
  {
    id: "batchId",
    value: "batchId",
    index: 6,
    numeric: true,
    label: "Batch Id",
    type: "string",
    width: 10,
    visible: false,
    filter: true,
  },
  {
    id: "createdBy",
    value: "createdBy",
    index: 11,
    numeric: true,
    label: "Created By",
    type: "string",
    width: 10,
    visible: false,
    filter: true,
  },
  {
    id: "createdAt",
    value: "createdAt",
    index: 12,
    numeric: true,
    label: "Created At",
    type: "date",
    width: 10,
    visible: false,
    filter: true,
  },
  {
    id: "modifiedBy",
    value: "modifiedBy",
    index: 13,
    numeric: true,
    label: "Modified By",
    type: "string",
    width: 10,
    visible: false,
    filter: true,
  },
  {
    id: "modifiedAt",
    value: "modifiedAt",
    index: 14,
    numeric: true,
    label: "Modified At",
    type: "date",
    width: 10,
    visible: false,
    filter: true,
  },
];

// IDisplayPairing
//  _id: any;
//  _old_id?: any;
//  baseICAO?: string;
//  positions: IPairingPosition[];
//  start: number;
//  end: number;
//  eventGroups: IDisplayPairingEventGroup[];

// PAIRINGS
export const pairingsTableDesc = {
  tableTitle: "Pairings",
  tableDescription: "",
  noMessage: "No pairings to display, use the filter above to search.",
};
export const pairingsTableInfo: ITableColumn[] = [
  {
    id: "_id",
    value: "_id",
    index: 0,
    numeric: true,
    label: "Short Code",
    type: "string",
    width: 10,
    visible: true,
    filter: false,
    sort: false,
  },
  {
    id: "positions",
    value: "positions",
    index: 1,
    numeric: true,
    label: "Positions",
    type: "object",
    width: 10,
    visible: true,
    filter: true,
  },
  {
    id: "eventGroups",
    value: "eventGroups",
    index: 2,
    numeric: true,
    label: "Pairing Events",
    type: "object",
    width: 10,
    visible: true,
    filter: true,
  },
  {
    id: "logicModifiers",
    value: "logicModifiers",
    index: 3,
    numeric: true,
    label: "LMs",
    type: "string",
    width: 10,
    visible: true,
    filter: true,
  },
  {
    id: "start",
    value: "start",
    index: 4,
    numeric: true,
    label: "Check-In",
    type: "date",
    width: 10,
    visible: true,
    filter: true,
  },
  {
    id: "end",
    value: "end",
    index: 5,
    numeric: true,
    label: "Check-Out",
    type: "date",
    width: 10,
    visible: true,
    filter: true,
  },
  {
    id: "baseICAO",
    value: "baseICAO",
    index: 6,
    numeric: true,
    label: "Base",
    type: "string",
    width: 10,
    visible: true,
    filter: true,
  },
  {
    id: "foreignRef",
    value: "foreignRef",
    index: 7,
    numeric: true,
    label: "Foreign Id",
    type: "array",
    width: 10,
    visible: true,
    filter: true,
  },
  {
    id: "batchId",
    value: "batchId",
    index: 8,
    numeric: true,
    label: "Batch Id",
    type: "array",
    width: 10,
    visible: true,
    filter: true,
  },
  {
    id: "createdBy",
    value: "createdBy",
    index: 9,
    numeric: true,
    label: "Created By",
    type: "string",
    width: 10,
    visible: false,
    filter: true,
  },
  {
    id: "createdAt",
    value: "createdAt",
    index: 10,
    numeric: true,
    label: "Created At",
    type: "date",
    width: 10,
    visible: false,
    filter: true,
  },
  {
    id: "modifiedBy",
    value: "modifiedBy",
    index: 11,
    numeric: true,
    label: "Modified By",
    type: "string",
    width: 10,
    visible: false,
    filter: true,
  },
  {
    id: "modifiedAt",
    value: "modifiedAt",
    index: 12,
    numeric: true,
    label: "Modified At",
    type: "date",
    width: 10,
    visible: false,
    filter: true,
  },
  {
    id: "shortDescription",
    value: "shortDescription",
    index: 13,
    numeric: true,
    label: "Short Description",
    type: "string",
    width: 10,
    visible: false,
    filter: false,
    sort: false,
  },
];

export interface ITableData {
  id: string;
  dataType: string;
  label: string;
  permissionResource: PolicyResource;
  data: any[];
  tableInfo: ITableColumn[];
  tableInfoDisplay: {
    tableTitle: string;
    tableDescription: string;
    noMessage: string;
  };
}
// Function used to create the dataSet needed for the table component.
// This particular dataSet contains an array with all the available data types for the advanced search functionality.
export const tableData: ITableData[] = [
  {
    id: "flights",
    dataType: "flights",
    label: "Flights",
    permissionResource: PolicyResource.Flight,
    data: [],
    tableInfo: assignedFlightsTableInfo,
    tableInfoDisplay: assignedFlightsTableDesc,
  },
  {
    id: "groundEvents",
    dataType: "groundEvents",
    label: "Ground Events",
    permissionResource: PolicyResource.GroundEvent,
    data: [],
    tableInfo: groundEventsTableInfo,
    tableInfoDisplay: groundEventsTableDesc,
  },
  {
    id: "pairings",
    dataType: "pairings",
    label: "Pairings",
    permissionResource: PolicyResource.Pairing,
    data: [],
    tableInfo: pairingsTableInfo,
    tableInfoDisplay: pairingsTableDesc,
  },
];
